export default __webpack_public_path__ + "static/media/PatriciaWilliams.cb47d6e2.png";